"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiUsers, FiDollarSign, FiTrendingUp, FiCalendar } from "react-icons/fi"
import "./Dashboard.css"

const Dashboard = () => {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDashboard()
  }, [])

  const loadDashboard = async () => {
    try {
      const response = await api.get("/dashboard")
      setStats(response.data)
    } catch (error) {
      console.error("Dashboard yüklenemedi:", error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
  }

  return React.createElement(
    "div",
    { className: "dashboard" },
    React.createElement("h1", null, "Dashboard"),
    React.createElement(
      "div",
      { className: "stats-grid" },
      React.createElement(
        "div",
        { className: "stat-card" },
        React.createElement("div", { className: "stat-icon blue" }, React.createElement(FiUsers)),
        React.createElement(
          "div",
          { className: "stat-content" },
          React.createElement("h3", null, "Toplam Müşteri"),
          React.createElement("p", { className: "stat-value" }, stats?.total_customers || 0),
        ),
      ),
      React.createElement(
        "div",
        { className: "stat-card" },
        React.createElement("div", { className: "stat-icon green" }, React.createElement(FiDollarSign)),
        React.createElement(
          "div",
          { className: "stat-content" },
          React.createElement("h3", null, "Toplam Gelir"),
          React.createElement("p", { className: "stat-value" }, `₺${stats?.total_income?.toLocaleString() || 0}`),
        ),
      ),
      React.createElement(
        "div",
        { className: "stat-card" },
        React.createElement("div", { className: "stat-icon red" }, React.createElement(FiTrendingUp)),
        React.createElement(
          "div",
          { className: "stat-content" },
          React.createElement("h3", null, "Net Kar"),
          React.createElement("p", { className: "stat-value" }, `₺${stats?.net_profit?.toLocaleString() || 0}`),
        ),
      ),
      React.createElement(
        "div",
        { className: "stat-card" },
        React.createElement("div", { className: "stat-icon purple" }, React.createElement(FiCalendar)),
        React.createElement(
          "div",
          { className: "stat-content" },
          React.createElement("h3", null, "Aylık Yeni Müşteri"),
          React.createElement("p", { className: "stat-value" }, stats?.monthly_new_customers || 0),
        ),
      ),
    ),
    React.createElement(
      "div",
      { className: "dashboard-grid" },
      React.createElement(
        "div",
        { className: "card" },
        React.createElement("h2", null, "Son Müşteriler"),
        stats?.recent_customers?.length > 0
          ? React.createElement(
              "div",
              { className: "customer-list" },
              stats.recent_customers.map((customer) =>
                React.createElement(
                  "div",
                  { key: customer.id, className: "customer-item" },
                  React.createElement(
                    "div",
                    null,
                    React.createElement("strong", null, `${customer.first_name} ${customer.last_name}`),
                    customer.company_name &&
                      React.createElement("span", { className: "company" }, ` - ${customer.company_name}`),
                  ),
                  React.createElement(
                    "span",
                    { className: "date" },
                    new Date(customer.created_at).toLocaleDateString("tr-TR"),
                  ),
                ),
              ),
            )
          : React.createElement("p", null, "Henüz müşteri yok"),
      ),
      React.createElement(
        "div",
        { className: "card" },
        React.createElement("h2", null, "En İyi Performans"),
        stats?.top_performers?.length > 0
          ? React.createElement(
              "div",
              { className: "performer-list" },
              stats.top_performers.map((user) =>
                React.createElement(
                  "div",
                  { key: user.id, className: "performer-item" },
                  React.createElement("span", null, `${user.first_name} ${user.last_name}`),
                  React.createElement("span", { className: "badge badge-info" }, `${user.customers_count} müşteri`),
                ),
              ),
            )
          : React.createElement("p", null, "Veri yok"),
      ),
    ),
  )
}

export default Dashboard
